import React from 'react';
import { Code, Layers, Share2, Users } from 'lucide-react';

const WelcomeModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const features = [
    {
      icon: <Code className="text-blue-500" size={24} />,
      title: '多语言支持',
      description: '支持HTML、CSS、JavaScript、TypeScript，语法高亮、智能提示'
    },
    {
      icon: <Layers className="text-green-500" size={24} />,
      title: '实时预览',
      description: '代码修改即时预览，iframe沙箱隔离，安全可靠'
    },
    {
      icon: <Share2 className="text-purple-500" size={24} />,
      title: '分享功能',
      description: '一键生成分享链接，支持项目下载和嵌入'
    },
    {
      icon: <Users className="text-orange-500" size={24} />,
      title: '协作编辑',
      description: '多人实时协作编辑，光标同步，操作广播'
    }
  ];

  const shortcuts = [
    { key: 'Ctrl + S', action: '保存/更新预览' },
    { key: 'Ctrl + Enter', action: '运行代码' },
    { key: 'Ctrl + N', action: '新建文件' }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-editor-panel rounded-lg p-8 max-w-2xl w-full max-h-[80vh] overflow-auto">
        <h1 className="text-3xl font-bold text-gray-200 mb-2">欢迎使用在线代码编辑器</h1>
        <p className="text-gray-400 mb-6">一个功能强大的在线代码编辑和协作平台</p>

        <div className="grid grid-cols-2 gap-4 mb-6">
          {features.map((feature, index) => (
            <div key={index} className="bg-editor-bg p-4 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">{feature.icon}</div>
                <div>
                  <h3 className="font-semibold text-gray-200 mb-1">{feature.title}</h3>
                  <p className="text-sm text-gray-400">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-200 mb-3">快捷键</h3>
          <div className="space-y-2">
            {shortcuts.map((shortcut, index) => (
              <div key={index} className="flex justify-between items-center bg-editor-bg p-2 rounded">
                <span className="text-gray-300 font-mono">{shortcut.key}</span>
                <span className="text-gray-400">{shortcut.action}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6 p-4 bg-blue-900 bg-opacity-30 rounded-lg border border-blue-700">
          <h3 className="text-blue-300 font-semibold mb-2">💡 使用提示</h3>
          <ul className="text-sm text-blue-200 space-y-1 list-disc list-inside">
            <li>在左侧文件树中创建和管理文件</li>
            <li>使用右侧工具栏添加外部库和分享项目</li>
            <li>TypeScript文件会自动编译为JavaScript</li>
            <li>控制台输出会在底部面板显示</li>
            <li>启动后端服务器可启用协作功能</li>
          </ul>
        </div>

        <button
          onClick={onClose}
          className="w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
        >
          开始使用
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
